import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, NavbarBrand, Nav, NavItem, Collapse, NavbarToggler } from 'reactstrap';
import '../../App.scss';

const FrontNav = () => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const url = window.location.href;
    return (
        <div className='header'>
            {url.includes('staging') || url.includes('localhost')
                ? <Navbar color='light' light expand='md'>
                    <NavbarBrand href='/'>Bond Reporting Tool</NavbarBrand>
                    <NavbarToggler onClick={toggle} />
                    <Collapse isOpen={isOpen} navbar>
                        <Nav className='mr-auto' navbar>
                            <NavItem>
                                <Link to='/Certificate' className='nav-link'>Completion Certificate</Link>
                            </NavItem>
                            <NavItem>
                                <Link to='/Portfolio' className='nav-link'>Portfolio Report</Link>
                            </NavItem>
                        </Nav>
                    </Collapse>
                </Navbar>
                : <></>}
        </div>
    );
};

export default FrontNav;
